import { Component, OnInit, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ExcelserviceService } from 'src/app/services/dhukan/excelservice.service'; // Service Import
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-importproduct',
  templateUrl: './importproduct.component.html',
  styleUrls: ['./importproduct.component.css']
})
export class ImportproductComponent implements OnInit {

  @Input() formname: any = 'Product';
  excelColl: any = [];
  importproductid = 0;
  showProgress: boolean = false;

  constructor(
    private toastr: ToastrService, 
    private appService: DhukanDataService,
    public loginService: LoginDataService, 
    public excelService: ExcelserviceService, 
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit() { }

  fnDownloadSampleFile() {
  const data = {
    columnDefs: [
      { headerName: 'RestaurantCode', field: 'restaurantcode' },
      // { headerName: 'SkuCode', field: 'skucode' },
      { headerName: 'ProductName', field: 'productname' },
      { headerName: 'Category', field: 'categoryname' },
      { headerName: 'SubCategory', field: 'subcategoryname' },
      { headerName: 'Uom', field: 'uom' },
      { headerName: 'UomQty', field: 'uomqty' },
      { headerName: 'TaxGroup', field: 'taxgroup' },
      { headerName: 'Price', field: 'price' },
      { headerName: 'FoodSymbol', field: 'foodsymbol' },
       { headerName: 'Description', field: 'descr' },
      // { headerName: 'SpecialCategory', field: 'specialcategory' },
      // { headerName: 'ProductTag', field: 'producttag' },
      { headerName: 'IsVariation', field: 'isvariation' },
      { headerName: 'VariationName', field: 'variationname' },
      { headerName: 'VariationUom', field: 'variationuomname' },
      { headerName: 'VariationQty', field: 'variationuomqty' },
      { headerName: 'VariationPrice', field: 'variationprice' },
      // { headerName: 'VariationCost', field: 'varcost' },
      // { headerName: 'VariationMrp', field: 'varmrp' },
      { headerName: 'VarIsOutOfStock', field: 'variationisoutofstock' },
      { headerName: 'VarIsDisplay', field: 'variationisdisplay' } 
    ],
    title: 'Product_Import_Template'
  };
  this.excelService.fnExportSampleTemplate(data);
}

  onFileChange(event: any) {
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) return;

    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      const data = XLSX.utils.sheet_to_json(ws, { defval: "" });
      this.excelColl = data;
      
      if(this.excelColl.length === 0) {
        this.toastr.warning("No data found in the selected file.");
      }
    };
  }

  fnReset() {
    this.excelColl = [];
    (document.getElementById('fileInput') as HTMLInputElement).value = "";
  }

  fnSaveBtnClick() {
  if (this.excelColl.length === 0) return;

  this.showProgress = true;
  let _dataColl = [];

  for (let row of this.excelColl) {
    var item = {
      restaurantcode: this.fnGetVal(row, 'RestaurantCode', 'restaurantcode'),
      // skucode: this.fnGetVal(row, 'SkuCode', 'skucode'),
      productname: this.fnGetVal(row, 'ProductName', 'productname'),
      categoryname: this.fnGetVal(row, 'Category', 'categoryname'),
      subcategoryname: this.fnGetVal(row, 'SubCategory', 'subcategoryname'),
      uom: this.fnGetVal(row, 'Uom', 'uom'),
      uomqty: this.fnGetVal(row, 'UomQty', 'uomqty') || "1", 
      taxgroup: this.fnGetVal(row, 'TaxGroup', 'taxgroup'),
      price: parseFloat(this.fnGetVal(row, 'Price', 'price')) || 0,
      foodsymbol: this.fnGetVal(row, 'FoodSymbol', 'foodsymbol'),
      // specialcategory: this.fnGetVal(row, 'SpecialCategory', 'specialcategory'),
      // producttag: this.fnGetVal(row, 'ProductTag', 'producttag'),    
      descr: this.fnGetVal(row, 'Description', 'descr'),
      isvariation: this.fnGetVal(row, 'IsVariation', 'isvariation')  ,
      variationname: this.fnGetVal(row, 'VariationName', 'variationname'),
      variationuomname: this.fnGetVal(row, 'VariationUom', 'variationuomname'), 
      variationuomqty: parseFloat(this.fnGetVal(row, 'VariationQty', 'variationuomqty')) || 0,
      variationprice: parseFloat(this.fnGetVal(row, 'VariationPrice', 'variationprice')) || 0,
      // cost: parseFloat(this.fnGetVal(row, 'VariationCost', 'varcost')) || 0,
      // mrp: parseFloat(this.fnGetVal(row, 'VariationMrp', 'varmrp')) || 0,
      variationisoutofstock: this.fnGetVal(row, 'VarIsOutOfStock', 'variationisoutofstock') ,
      variationisdisplay: this.fnGetVal(row, 'VarIsDisplay', 'variationisdisplay') ,
      modifiedby: this.loginService.fnGetModUserId()
      
    };
    _dataColl.push(item);
  }

  this.fnInsertExcelImport(_dataColl);
}

fnGetVal(row: any, key1: string, key2: string) {
  let val = row[key1] !== undefined ? row[key1] : row[key2];
  return val !== undefined ? val.toString().trim() : "";
}

fnInsertExcelImport(_dataColl) {
  var data = {
    filename: 'Product_Import_' + new Date().getTime(),
    modifiedby: this.loginService.fnGetModUserId(),
    restaurantid: this.loginService.fnGetModRestaruntId(),
    importdetailscoll: _dataColl
  };

  this.showProgress = true;

  this.appService.fnInsertImportProduct(data).subscribe((res) => {
    const response = res.json();
    
    if (response.status === 200) {
    this.importproductid = response.result[0].importproductid;
      
      if (this.importproductid != 0) {
        var proceedParams = {
          'importproductid': this.importproductid,
        };

        this.appService.fnsetimportproceedexcel(proceedParams).subscribe((syncRes) => {
          this.showProgress = false;
          const syncResponse = syncRes.json();
          
          if (syncResponse.status === 200) {
            this.toastr.success('Success', "Product Import Sync Successfully");
            this.activeModal.close('DONE');
          } else {
            this.toastr.error('Sync Error', syncResponse.err_message || "Failed to sync data.");
          }
        }, (err) => {
          this.showProgress = false;
          this.toastr.error('Error', "Proceed Sync API failed.");
        });
      } else {
        this.showProgress = false;
        this.toastr.warning('Warning', "Import ID not received from server.");
      }

    } else {
      this.showProgress = false;
      this.toastr.error('Error', response.err_message || "Initial Import failed.");
    }
  }, (err) => {
    this.showProgress = false;
    this.toastr.error('Error', "Server connection error.");
  });
}

  public decline() {
    this.activeModal.close(false);
  }
}